export const PHASE = "dev";
export const API_LOCAL = "http://localhost:8021/api/v3";
export const API = "https://82as0chvo5.execute-api.us-west-2.amazonaws.com/dev/api/v3";